module.exports = '<svg width="57" height="32" viewBox="0 0 57 32"><path d="M51.236 30.993l-22.68-22.68-22.68 22.68a3.448 3.448 0 0 1-4.869 0 3.448 3.448 0 0 1 0-4.869L26.122 1.013a3.435 3.435 0 0 1 4.865 0l25.115 25.111a3.448 3.448 0 0 1 0 4.869 3.443 3.443 0 0 1-4.865 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/control-1.js
// module id = 1091
// module chunks = 14